<script>
  import { HorizontalBar, mixins } from 'vue-chartjs'
  const { reactiveData } = mixins

  export default {
    extends: HorizontalBar,
    mixins: [reactiveData],
    props: ['data'],
    mounted () {
      this.renderChart(this.chartData, this.options)
    },
    watch: {
      data: function (newData, oldData) {
        this.chartData = newData.report
        this.options = newData.options
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HorizontalBarChart.vue?3cbc68dc